import React from 'react';

import { type BaseSvgProps, colorToHexCode } from '../../utils';

export const Pencil = ({
  width = 12,
  primaryColorHexCode = colorToHexCode.black,
  'data-testid': testId,
}: BaseSvgProps) => (
  <svg
    data-testid={testId}
    width={width}
    height={width}
    viewBox="0 0 11 12"
    className="shrink-0"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.75 1.75L9.5 3.5L3.75 9.25L1.5 9.75L2 7.5L7.75 1.75Z"
      stroke={primaryColorHexCode}
      strokeWidth="1"
      strokeLinejoin="round"
    />
    <path d="M6.75 2.75L8.5 4.5" stroke={primaryColorHexCode} strokeWidth="1" />
  </svg>
);
